import script from "./Scrollow.vue?vue&type=script&setup=true&lang=js"
export * from "./Scrollow.vue?vue&type=script&setup=true&lang=js"

import "./Scrollow.vue?vue&type=style&index=0&id=9e28b2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e28b2a4"]])

export default __exports__